import { format } from "date-fns";
import { LuDownload } from "react-icons/lu";

import { useViewModal } from "./use-view-modal";
import { Button } from "@/components/ui/button/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";

export const ViewAnnouncementModal = () => {
  const { open, onOpenChange, announcement } = useViewModal();

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle className="tracking-normal">
              {announcement?.title}
            </DialogTitle>
          </DialogHeader>

          <div className="mt-5">
            <div className="flex flex-row items-center gap-2">
              {announcement?.createdAt && (
                <div className="flex flex-row items-center text-sm">
                  Created At -{" "}
                  {format(new Date(announcement?.createdAt as string), "PPpp")}{" "}
                </div>
              )}
            </div>

            <p className="mt-3">{announcement?.description}</p>

            <div className="flex flex-col gap-2 mt-3">
              {announcement?.files &&
                announcement?.files?.map((file, index) => {
                  return (
                    <Button
                      key={index}
                      size="sm"
                      variant="outline"
                      className="flex items-center gap-1 font-normal"
                      asChild
                    >
                      <a
                        href={file}
                        download="Download Attachment"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <LuDownload /> Attachment
                      </a>
                    </Button>
                  );
                })}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
